// @flow
// eslint-env browser

export function createScrollHandler(handler: () => void) {
    window.addEventListener('scroll', handler);
    return { remove: () => window.removeEventListener('scroll', handler) };
}
